import {FileManager} from '../../shared/Models/FileManager';

export class FabricColor {
  static ACTIVE = 'active';
  static INACTIVE = 'inactive';
  public id: number;
  public image: FileManager | any;
  public name: string;
  public supplier: string;
  public position: number;
  public status: boolean;
  public fabric: number;
  public parentPosition: number;
}
